import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-container inspection" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = {
  key: 0,
  class: "customer"
}
const _hoisted_5 = { class: "container flex-grow-1 workorders" }
const _hoisted_6 = { class: "wo-details" }
const _hoisted_7 = { class: "customer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Customer:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Vehicle:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Plate:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Odometer:", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "Vehicle:", -1)
const _hoisted_15 = { class: "lead text-muted" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode("Odometer In"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "error"
}
const _hoisted_18 = { class: "lead text-muted" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode("Odometer Out"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_20 = {
  key: 0,
  class: "error"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Loading inspections "),
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner" })
], -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = {
  key: 1,
  class: "container flex-grow-1"
}

import { useAuth0 } from "@auth0/auth0-vue";
import { ref } from "@vue/reactivity";
import { onMounted, onBeforeMount, computed, inject } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from "../store";
import { MutationTypes } from "../store/mutations";
import { FilterMatchMode } from 'primevue/api';
import { useToast } from 'primevue/usetoast';
import { useVuelidate } from '@vuelidate/core';
import { numeric, required, helpers } from '@vuelidate/validators';
import { useConfirm } from "primevue/useconfirm";
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';


export default /*#__PURE__*/_defineComponent({
  name: 'DVIWorkOrderPackages',
  setup(__props) {

const auth0 = useAuth0();
const items = ref([]);
const posthog = inject("posthog");
const filters = ref({
  'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
});

const role = ref('');
const storestatus = ref('');
const loading = ref(false);
const empty = ref(false);
const updateOdometerDialog = ref(false);
const router = useRouter();
const store = useStore();
const confirm = useConfirm();
const toast = useToast();
const currentWorkOrderNumber = computed(() => store.state.currentWorkOrderNumber);
const currentWorkOrderID = computed(() => store.state.currentWorkOrderID);
const storeid = computed(() => store.state.storeid);
store.commit(MutationTypes.SET_CURRENTDVIWO_BYID, currentWorkOrderNumber.value);
const currentDVIWO = computed(() => store.state.currentdviwoitem);
const lastname = currentDVIWO.value?.LastName;
const firstname = currentDVIWO.value?.FirstName;
const make = currentDVIWO.value?.Make;
const model = currentDVIWO.value?.Model;
const color = currentDVIWO.value?.Color;
const plate = currentDVIWO.value?.Plate;
const InUsage = ref(0);
const OutUsage = ref(0);
const InUsageComputed = computed(() => new Intl.NumberFormat().format(currentDVIWO.value?.InUsage ?? 0));

const rules = computed(() => ({
  InUsage: {numeric: helpers.withMessage('Odometer In must be number', numeric), required: helpers.withMessage('Value required for Odometer In', required) },
  OutUsage: { numeric: helpers.withMessage('Odometer Out must be number', numeric), required: helpers.withMessage('Value required for Odometer Out', required) }
}));
const v$ = useVuelidate(rules, { InUsage, OutUsage });

/**
 * checkAllInspectionResults will return true if all items have Status
 */
const submitWorkOrderStatus = computed(() => {
  let submitValue = true;
  for (let itemIndex = 0; itemIndex < items.value.length; itemIndex++) {
    if (checkAllInspectionResults(items.value[itemIndex]) === false) {
      submitValue = false;
      break;
    }
  }

  return submitValue
});

/**
 * On before mount sets the initial data
 */
onBeforeMount(async () => {
  role.value = store.state.role;
  storestatus.value = store.state.storestatus;
  if (storestatus.value == 'Disable')
    router.push('/storedisable');
}
);

/**
 * Call load work order package and work order function in order to populate WO items
 */
onMounted(async () => {
  const dviworkoderpackages = currentDVIWO.value?.WorkOrderPackages;
  if (dviworkoderpackages !== null && dviworkoderpackages !== undefined) {
    items.value = dviworkoderpackages;
  } else {
    loadWorkOrderPackages();
  }
});

/**
 * Load work order packages and assign data by VUE mutation
 */
const loadWorkOrderPackages = async () => {
  loading.value = true;
  const store = useStore();
  const accessToken = await auth0.getAccessTokenSilently();
  const WOurl = process.env.VUE_APP_NODEJS_BASE_URL + "dviworkorders/" + storeid.value + "/" + currentWorkOrderID.value;
  try {
    const response = await fetch(WOurl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    loading.value = false;
    const data = await response.json();
    if (response.status > 400) {
      throw new Error(JSON.stringify(data.error));
    }
    const ServicePackages = data.message.ServicePackages;

    //in state, set WorkOrderPackages into current WorkOrder's WorkOrderPackages[] property
    store.commit(MutationTypes.SET_DVIWOPACKAGESONCURRENTWO, ServicePackages);
    items.value = ServicePackages;
    InUsage.value = data.message.InUsage;
    OutUsage.value = data.message.OutUsage;
    store.commit(MutationTypes.UPDATE_ODOMETER, { WorkOrderNumber: currentWorkOrderNumber.value, InUsage: InUsage.value, OutUsage: OutUsage.value });

    if ((items.value.length) < 1)
      empty.value = true;
    else
      empty.value = false;
  } catch (e) {
    openErrorModal(e.message);
  }
}

/**
 * Sends query to update page via router push
 * @param event 
 */
const onRowSelect = (event) => {
  store.commit(MutationTypes.SET_CURRENTWORKORDERPACKAGEID, event.data.WorkOrderPackageID);
  store.commit(MutationTypes.SET_CURRENTWORKORDERPACKAGEHEADER, event.data.WorkOrderPackageHeader);
  router.push({ name: 'dviupdateworkorderpackage', params: { workorderpackageid: event.data.WorkOrderPackageID, workorderpackageheader: event.data.WorkOrderPackageHeader } });
};

/**
 * Sends query to summary page via router push
 * @param prod 
 */
const gotoSummary = async (prod) => {
  const rowdata = { ...prod };
  store.commit(MutationTypes.SET_CURRENTWORKORDERPACKAGEID, rowdata.WorkOrderPackageID);
  store.commit(MutationTypes.SET_CURRENTWORKORDERPACKAGEHEADER, rowdata.WorkOrderPackageHeader);
  router.push({ name: 'dvisummaryworkorderpackage', params: { workorderpackageid: rowdata.WorkOrderPackageID, workorderpackageheader: rowdata.WorkOrderPackageHeader } });
}

/**
 * Function to open update odometer dialog
 */
const openUpdateOdometerDialog = () => {
  InUsage.value = currentDVIWO.value?.InUsage ?? 0;
  OutUsage.value = currentDVIWO.value?.OutUsage ?? 0;
  updateOdometerDialog.value = true;
}

/**
 * Update odometer
 */
 const updateOdometer = async () => {
  if (!await v$.value.$validate()) return;
  updateOdometerDialog.value = false;
  let odometerdata = {
    InUsage: InUsage.value,
    OutUsage: OutUsage.value
  };
  const accessToken = await auth0.getAccessTokenSilently();
  const url = process.env.VUE_APP_NODEJS_BASE_URL + "dviworkorders/odometer/" + storeid.value + "/" + currentWorkOrderID.value;
  try {
    const response: Response = await fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(odometerdata),
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
    });
    const data = await response.json();
    if (response.status > 400) {
      throw new Error(JSON.stringify(data.error));
    }
    
    //update vuex state for odometer
    const store = useStore();
    store.commit(MutationTypes.UPDATE_ODOMETER, { WorkOrderNumber: currentWorkOrderNumber.value, InUsage: InUsage.value, OutUsage: OutUsage.value });

    v$.value.$reset();
    toast.add({ severity: 'success', summary: 'Successful', detail: 'Updated odometer in and out', life: 3000 });
  } catch (e) {
    openErrorModal(e.message);
  }
}

/**
 * Iterate all inspection items with Type Line
 * and verify if all items have existing Result status value
 * @param inspectionItems 
 */
const checkAllInspectionResults = (inspectionItems) => {
  return inspectionItems.WorkOrderPackageInspectionLines
    .filter((item) => item.Type === 'Line')
    .every((item) => item.Result.trim() !== '');
}

/**
 * Iterate all inspection items with type line
 * and verify if some items have Result value
 * @param inspectionItems 
 */
const checkAllInspectionResultsSome = (inspectionItems) => {
  return inspectionItems.WorkOrderPackageInspectionLines
    .filter((item) => item.Type === 'Line')
    .some((item) => item.Result.trim() !== '');
}

/**
 * Submit workorder consists of 2 asynchronous method, save inspections and complete workorder
 */
 const submitWorkOrder = async () => {
  confirm.require({
    message: 'Are you sure you want to mark this Work Order Completed?',
    header: 'Please confirm submit',
    icon: 'pi pi-exclamation-circle',
    acceptClass: 'p-button-primary',
    accept: async () => {
      const { email }  = { ...auth0.user.value };
      const storeid = auth0.user.value['http://protractor.com/storeid'];
      posthog.capture("dviwocompleted_button_clicked", { email: email, storeid: storeid });
      await completeWorkorder();
    }
  });
}

/**
 * Submit a work order as complete then redirect to DVIWorkorders page
 */
const completeWorkorder = async () => {
  const accessToken = await auth0.getAccessTokenSilently();
  const url = process.env.VUE_APP_NODEJS_BASE_URL + "dviworkorders/workflow/" + storeid.value + "/" + currentWorkOrderID.value;
  try {
    const response: Response = await fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();
    if (response.status > 400) {
      throw new Error(JSON.stringify(data.error));
    }
    router.push({ name: 'dviworkorders', params: { completed: 'completed' } });
  } catch (e) {
    openErrorModal(e.message);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmDialog),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          _createTextVNode("Inspections for WO# " + _toDisplayString(_unref(currentWorkOrderNumber)) + " ", 1),
          _createVNode(_component_Button, {
            style: {"margin-bottom":".1rem !important"},
            type: "button",
            icon: "pi pi-refresh",
            class: "p-button-text p-button-rounded",
            onClick: loadWorkOrderPackages
          })
        ])
      ]),
      (items.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Button, {
              disabled: !_unref(submitWorkOrderStatus),
              onClick: submitWorkOrder,
              label: "Inspection(s) Complete",
              class: "p-button p-component p-button-rounded btn-primary sml odo"
            }, null, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("span", null, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_unref(firstname)) + " " + _toDisplayString(_unref(lastname)), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_unref(color)) + " " + _toDisplayString(_unref(make)) + " " + _toDisplayString(_unref(model)), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_unref(plate)), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_unref(InUsageComputed)), 1)
          ])
        ]),
        (items.value.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
              _createVNode(_component_Button, {
                onClick: openUpdateOdometerDialog,
                label: "Update Odometer",
                class: "p-button p-component p-button-rounded btn-secondary sml odo",
                style: {"margin-right":".3rem"}
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Dialog, {
        visible: updateOdometerDialog.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((updateOdometerDialog).value = $event)),
        header: "Update Odometer",
        modal: true,
        class: "p-fluid"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Update",
            class: "p-button p-component p-button-rounded btn-primary",
            onClick: updateOdometer
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", null, [
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(_unref(color)) + " " + _toDisplayString(_unref(make)) + " " + _toDisplayString(_unref(model)) + ", " + _toDisplayString(_unref(plate)), 1)
            ]),
            _createElementVNode("p", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_InputNumber, {
                inputId: "integeronly",
                id: "InUsage",
                modelValue: InUsage.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((InUsage).value = $event)),
                class: _normalizeClass({ 'p-invalid': _unref(v$).InUsage.$error }),
                required: "true"
              }, null, 8, ["modelValue", "class"]),
              (_unref(v$).InUsage.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(v$).InUsage.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_InputNumber, {
                inputId: "integeronly",
                id: "OutUsage",
                modelValue: OutUsage.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((OutUsage).value = $event)),
                class: _normalizeClass({ 'p-invalid': _unref(v$).OutUsage.$error }),
                required: "true"
              }, null, 8, ["modelValue", "class"]),
              (_unref(v$).OutUsage.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(v$).OutUsage.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      (!empty.value)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            value: items.value,
            paginator: true,
            rows: 10,
            stripedRows: "",
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            rowsPerPageOptions: [10, 20, 50],
            breakpoint: "640px",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
            filters: filters.value,
            selectionMode: "single",
            onRowSelect: onRowSelect,
            loading: loading.value,
            dataKey: "WorkOrderPackageID"
          }, {
            loading: _withCtx(() => [
              _hoisted_21
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                class: "wo-item",
                field: "WorkOrderPackageHeader",
                header: "Type",
                sortable: true
              }),
              _createVNode(_component_Column, {
                class: "wo-status",
                header: "Status",
                sortable: true
              }, {
                body: _withCtx((slotProps) => [
                  (checkAllInspectionResults(slotProps.data))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Items Complete"))
                    : (checkAllInspectionResultsSome(slotProps.data))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "In Progress"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, "Pending"))
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                class: "wo-action",
                header: " "
              }, {
                body: _withCtx((slotProps) => [
                  (checkAllInspectionResults(slotProps.data))
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        label: "Summary",
                        class: "p-button-rounded btn-primary sml blocked",
                        onClick: ($event: any) => (gotoSummary(slotProps.data))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "filters", "loading"]))
        : _createCommentVNode("", true),
      (empty.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, "No inspections found."))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})